import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import RegistrationSteps from "@/modules/frontend/components/RegistrationSteps";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import Counter from "@/modules/frontend/components/Counter";

import DigitalReach from "@/assets/images/webp/Digital-Reach.webp";
import VerifiedLeads from "@/assets/images/webp/verified-leads.webp";
import partnerWithUs from "@/assets/images/webp/become-supplier-img.webp";
import CustomerService from "@/assets/images/webp/Customer-Service.webp";
import HSNCodeAccess from "@/assets/images/webp/HSN-Code-Access.webp";
import GlobalLogisticsSupport from "@/assets/images/webp/Global-Logistics-Support.webp";
import DigitalIdentity from "@/assets/images/webp/Digital-Identity.webp";
import GlobalMarketAccess from "@/assets/images/webp/Global-Market-Access.webp";
import { publicRoutePaths } from "@/routes/public.routes.config";


const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  return (
    <>
      {/* inner banner wrape START  */}
      <section className="inner-banner become-supplier-page">
        <SeoHelmet
          title={seoConfig.supplier.title}
          description={seoConfig.supplier.description}
          keywords={seoConfig.supplier.keywords}
          author={seoConfig.supplier.author}
        />
        <button
          className="btn outline small sticky-btn"
          onClick={handleQuoteClick}
          type="button"
        >
          Book A Demo
        </button>
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              <motion.span className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Helping Your</motion.span>
              <motion.span className="blue-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Business Expand</motion.span>
              <motion.span className="black animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Worldwide</motion.span>
            </h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Expand your global presence, connect with trusted buyers and build long-term partnerships</motion.p>
          </div>
        </div>
      </section>
      {/* inner banner wrape END  */}

      {/* why partner wrape START  */}
      <section className="why-partner-section inner-page-content-wrape become-supplier-page">
        <div className="container">
          <div className="content-wrape mobile-show page-head">
            <motion.h2 className="mobile-head-text animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <motion.span className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Helping Your</motion.span>
              <motion.span className="blue-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Business Expand</motion.span>
              <motion.span className="black animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > WorldWide</motion.span>
            </motion.h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Expand your global presence, connect with trusted buyers and build long-term partnerships</motion.p>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className="img-wrape">
                <Link to={publicRoutePaths.REGISTRATION.path} href={publicRoutePaths.REGISTRATION.path} target="_blank">
                  <motion.img src={partnerWithUs} alt="partner-with-orex" loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </Link>

              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className="head-text">
                <motion.h2 className="head animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Why Partner With Us?</motion.h2>
              </div>
              <motion.p
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >At Orex Trade World INC, We offer a comprehensive suite of services to help businesses thrive in the global marketplace. Our network ensures secure trade protection, giving you peace of mind while conducting transactions across borders. Benefit from powerful marketing support that promotes your products to the right audience and expert business assistance that guides you through international trade challenges. With easy-to-use tools, you can manage your operations efficiently, track opportunities and connect with verified buyers and suppliers worldwide.</motion.p>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                Our flexible subscription plans cater to businesses of all sizes, while our network of trusted global partners makes expanding into new markets seamless. Orex Trade simplifies global trading, enabling your business to operate safely, efficiently and successfully and helping you unlock new growth opportunities at every step.
              </motion.p>

              <div className="statistics-wrape-benefit">
                <div className="statistics-content">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span><Counter end={6} duration={0.1} decimals={0} suffix="+" /> Millions</span>
                    <p>
                      Global Buyers
                    </p>
                  </motion.div>
                </div>
                <div className="statistics-content big">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span>
                      <Counter end={80} duration={2} suffix="+" /> Countries
                    </span>
                    <p>
                      Globally Serve
                    </p>
                  </motion.div>
                </div>
              </div>

              <motion.div className="button-wrape animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <Link className="btn outline" to={publicRoutePaths.REGISTRATION.path} target="_blank" href={publicRoutePaths.REGISTRATION.path}>
                  Become a Partner
                  <span className="round">
                    <i className="sprite"></i>
                  </span>
                </Link>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* why partner wrape END */}

      {/* digital identity wrape START */}
      <section className="digital-identity-wrape">
        <div className="inner-pad-bg">
          <div className="head-text center container semi-large">
            <motion.h2 className="head center animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              Your company’s digital identity - a profile that builds trust and attracts the right partners.
            </motion.h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >There is no one who loves pain itself, who seeks after it and wants to have it, simply because it is pain...</motion.p>
          </div>
          <div className="container point-wrape">
            <div className="point-pad">
              <div className="section left-points">
                <motion.p className="point animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Present a clear and comprehensive overview of your business along with your cooperation terms.</motion.p>
                <motion.p className="point animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Showcase your entire product catalog to reach a wider audience.</motion.p>
              </div>
              <div className="section image-wrape">
                <motion.img src={DigitalIdentity} alt="Digital-Identity" loading="lazy" className="animate-child"></motion.img>
              </div>
              <div className="section right-points">
                <motion.p className="point animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Enhance your profile with photos and videos that highlight your company.</motion.p>
                <motion.p className="point animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Upload key documents and presentations for potential buyers</motion.p>
                <motion.p className="point animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Highlight your certifications to strengthen trust and credibility.</motion.p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* digital identity wrape END */}

      {/* benefit partnering wrape START  */}
      <section className="benefit-partnering-wrape">
        <div className="head-text center container semi-large">
          <motion.h2 className="head center animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          >Benefits of Partnering With Orex Trade</motion.h2>
          <motion.p className="animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          >Reach verified buyers worldwide, streamline trade and grow your brand with trusted partnerships</motion.p>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={GlobalMarketAccess} alt="Global Market Access" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Global Market Access</motion.h6>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Showcase your products to buyers across six continents.Gain visibility, build partnerships and drive international growth
                  </motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={VerifiedLeads} alt="Verified Buyer Leads" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Verified Buyer Leads</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Access genuine business leads from verified sources and connect with serious buyers to grow your business with confidence</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={DigitalReach} alt="Digital Reach" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Digital Reach</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Boost your business with digital promotions, seasonal campaigns and targeted ads to reach the right audience worldwide</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={GlobalLogisticsSupport} alt="Global Logistics Support" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Global Logistics Support</motion.h6>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                    className="animate-child"
                  >Partner with reliable logistics providers to streamline shipping, ensure timely delivery and expand your global reach</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={HSNCodeAccess} alt="HSN Code Access" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >HSN Code Access</motion.h6>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Access accurate HSN codes to ensure compliance, prevent delays and enable smooth, hassle-free global trade</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={CustomerService} alt="Customer Service" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Customer Service</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Our dedicated support team ensures your journey on Orex Trade is effortless, guiding you whenever you need assistance</motion.p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* benefit partnering wrape END  */}

      {/* stepper wrape START  */}
      <RegistrationSteps sectionTitle="All you have to do is follow these simple steps" pageName="supplier" subTitle="Follow this guided process to set up your account and begin trading confidently" />
      {/* stepper wrape END  */}
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  )
}

export default Index;